var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 51,
    viewBox: "0 0 66 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "-134.648%",
    x2: "184.926%",
    y1: "100%",
    y2: "-81.012%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#43B6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#33EEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "4.248%",
    x2: "95.826%",
    y1: "86.836%",
    y2: "18.008%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#43B6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#33EEC7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 38,
    x: 1,
    y: 12,
    fill: "#33EEC7",
    opacity: 0.2,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 11.5,
    r: 11.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)",
    fillRule: "nonzero",
    transform: "translate(9.011 29.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.241 12.135a.9.9 0 0 1-.616-.241l-10.37-9.58a.874.874 0 0 1-.04-1.253.907.907 0 0 1 1.273-.039l10.37 9.58a.874.874 0 0 1 .04 1.252.899.899 0 0 1-.657.28zM1.63 12.135a.899.899 0 0 1-.657-.28.875.875 0 0 1 .04-1.253l10.37-9.583a.908.908 0 0 1 1.272.039c.34.356.325.919-.04 1.253l-10.37 9.583a.9.9 0 0 1-.616.24z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M51.385 50.604H4.505C2.02 50.604 0 48.614 0 46.168V15.914c0-2.447 2.02-4.437 4.506-4.437h38.252c.498 0 .901.398.901.888s-.403.887-.9.887H4.505c-1.49 0-2.704 1.194-2.704 2.662v30.255c0 1.468 1.213 2.662 2.704 2.662h46.88c1.49 0 2.703-1.194 2.703-2.662V24.41c0-.49.403-.887.9-.887.498 0 .902.397.902.887v21.76c0 2.446-2.02 4.435-4.506 4.435z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M27.958 35.499c-1.202 0-2.406-.394-3.321-1.179L1.359 14.311a.88.88 0 0 1-.087-1.252.913.913 0 0 1 1.273-.086L25.822 32.98c1.152.992 3.1.998 4.257.01l15.372-13.108a.91.91 0 0 1 1.27.09c.326.371.285.93-.092 1.252L31.258 34.33c-.908.779-2.105 1.168-3.3 1.168z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M48 11.333L54.538 18 65 6",
    transform: "translate(0 -1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.cdfd1b22315f6217a029cd50c2044728.svg";
export { ForwardRef as ReactComponent };